import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    none: translate({ id: 'global.none' }),
    label: translate({ id: 'orders.viewDetails.label.company' }),
  }))

  return api
}
